export const locale = {
  progress_title: 'Agreements and Acknowledgments',
  cancel: 'DISAGREE/DECLINE',
  accept: 'AGREE',
};
